import { ReactComponent as ViewAssessmentIcon } from 'assets/icons/ViewAssessment.svg';
import { ReactComponent as ReportIcon } from 'assets/icons/Report.svg';
import { ReactComponent as ChoicesIcon } from 'assets/icons/Choices.svg';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { categories } from 'keys';
import { AssessmentWords } from 'pages/School/Assessment'
import { ChallengesTabs, MultlpleChoiceQuestions } from '..'

const useReportDisplayBtns = () => {
    const { assessment } = useSelector(state => state.assessment)
    const { reading_assessment_category_name: category } = assessment || {}

    
    const assessmentWithQuestion =
        category == categories.INFORMATIONAL_TEXT_NO_NIKUD ||
        category == categories.INFORMATIONAL_TEXT ||
        category == categories.NARRATIVE_TEXT ||
        category == categories.NARRATIVE_TEXT_NO_NIKUD ||
        category == categories.BIBLICAL_TEXT

    const btns = useMemo(
        () => [
            {
                key: "assessmentView",
                icon: ViewAssessmentIcon,
                action: () => { },
                tooltip: "תצוגת דוח",
                placement: "top",
                fontSize: "small",
                component: AssessmentWords
            },
            {
                key: "questions",
                icon: ChoicesIcon,
                placement: "top",
                action: () => { },
                tooltip: "הבנת הנקרא",
                fontSize: "small",
                disabled: !assessmentWithQuestion,
                component: MultlpleChoiceQuestions
            },
            {
                key: "report",
                icon: ReportIcon,
                action: () => { },
                fontSize: "small",
                tooltip: "דוח מפורט",
                placement: "top",
                component: ChallengesTabs
            },
        ], [assessmentWithQuestion]
    )

    return btns
}

export default useReportDisplayBtns